import * as general from './general'

export const statusHelper = {
  general,
}
